import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataGridModule } from '@shared/components/data-grid/data-grid.module';
import { ButtonModule } from '@shared/components/button/button.module';
import { MaterialModule } from '@app/material/material.module';

import { InsertQuestionDialogComponent } from './insert-question-dialog.component';

@NgModule({
  declarations: [InsertQuestionDialogComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DataGridModule,
    MaterialModule
  ],
  exports: [InsertQuestionDialogComponent],
  entryComponents: [InsertQuestionDialogComponent]
})
export class InsertQuestionDialogModule { }
